import { FC, useEffect, useState } from "react";
import avatar from "./../../../assets/img/avatar.png";
import { UserProfile } from "../types/profile-types";
import { protectedApi } from "../../../api/axiosClient";
import { useAuthContext } from "../../Auth/context/auth-context";
import LoadSpinner from "../../Reusable/LoadSpinner";
import SelectLocation from "../../Reusable/SelectLocation";
import { Category } from "../../HomePage/types";

const UserForm: FC<{}> = () => {
  const { user } = useAuthContext();

  const [profileData, setProfileData] = useState<UserProfile>({
    profile_picture: "",
    first_name: "",
    last_name: "",
    remote: false,
    location_dict: {
      id: 0,
      name: "",
    },
  });

  const [profilePicture, setProfilePicture] = useState<File | null>(null);
  const [loading, setLoading] = useState(true);

  //fill form with existing user data
  useEffect(() => {
    const fetchProfile = async () => {
      try {
        const response = await protectedApi.get(`accounts/users/${user?.id}`);
        setProfileData(response.data);
        setLoading(false);
      } catch (error) {
        setLoading(false);
      }
    };

    fetchProfile();
  }, [user?.id]);

  // Handle file input changes
  const handleFileChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (e.target.files && e.target.files[0]) {
      const file = e.target.files[0];
      setProfilePicture(file);

      // Use FileReader to display a preview of the image
      const reader = new FileReader();
      reader.onloadend = () => {
        setProfileData({
          ...profileData,
          profile_picture: reader.result as string, // Set the preview URL
        });
      };
      reader.readAsDataURL(file); // Read the selected file as a data URL
    }
  };

  // Handle form submission
  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();

    const formData = new FormData();

    // Append all fields to the form data
    // formData.append("id", `${user?.id}`);
    formData.append("first_name", profileData.first_name);
    formData.append("last_name", profileData.last_name);
    formData.append("location", profileData.location_dict.id.toString());
    formData.append("remote", String(profileData.remote));

    // If a new profile picture is selected, append it
    if (profilePicture) {
      formData.append("profile_picture", profilePicture);
    }

    try {
      // Send PUT request to update user profile
      const response = await protectedApi.put(
        `accounts/users/${user?.id}/`,
        formData
      );
      alert("Zaktualizowano pomyślnie!");
    } catch (error) {
      console.error("Error updating profile:", error);
      alert("Błąd podczas aktualizacji. Spróbuj ponownie.");
    }
  };

  // Handle delete profile picture
  const handleDeleteProfilePicture = async () => {
    try {
      // Send PUT request to remove the profile picture (set it to null)
      const response = await protectedApi.put(`accounts/users/${user?.id}/`, {
        ...profileData,
        profile_picture: null, // Delete the profile picture
      });
      setProfileData(response.data); // Update profile data after deletion
      setProfilePicture(null); // Reset the local state for profile picture
      alert("Pomyślnie usunięto Twoje zdjęcie profilowe!");
    } catch (error) {
      console.error("Error deleting profile picture:", error);
    }
  };
  return (
    <>
      {loading ? (
        <LoadSpinner />
      ) : (
        <form onSubmit={handleSubmit}>
          <div className="form-row-2">
            <div className="form-col-2">
              <label htmlFor="">
                {profileData.profile_picture ? "Zmień " : "Dodaj "}Zdjęcie
                profilowe
              </label>
              <input
                type="file"
                accept="image/*" // Restrict to image files only
                onChange={handleFileChange}
              />
              {profileData.profile_picture && (
                <button
                  type="button"
                  className="btn btn-light"
                  onClick={handleDeleteProfilePicture}
                >
                  Usuń zdjęcie profilowe
                </button>
              )}
            </div>
            <div className="profile-image-circle">
              <img
                src={profileData.profile_picture || avatar}
                alt="Profile picture"
              />
            </div>
          </div>
          <div className="form-row-2">
            <div className="form-col-2">
              <label htmlFor="name">Imię</label>
              <input
                className="form-input"
                value={profileData.first_name}
                type="text"
                id="name"
                onChange={(e) =>
                  setProfileData({ ...profileData, first_name: e.target.value })
                }
              />
            </div>
            <div className="form-col-2">
              <label htmlFor="surname">Nazwisko</label>
              <input
                className="form-input"
                value={profileData.last_name}
                type="text"
                id="surname"
                onChange={(e) =>
                  setProfileData({ ...profileData, last_name: e.target.value })
                }
              />
            </div>
          </div>
          <div className="form-row-2">
            <div className="form-col-2">
              <label htmlFor="city">Miasto</label>
              <SelectLocation
                remote={false}
                selectedLocation={profileData.location_dict}
                setLocation={(loc: Category) =>
                  setProfileData((prev) => ({
                    ...prev,
                    location_dict: loc,
                  }))
                }
              />
            </div>
            <div className="checkbox-col">
              <label htmlFor="remote">
                {user?.is_trainer
                  ? "Prowadzę zajęcia zdalnie"
                  : "Akceptuję zajęcia zdalne"}
              </label>
              <input
                className="form-input"
                checked={profileData.remote}
                type="checkbox"
                id="remote"
                onChange={(e) =>
                  setProfileData({
                    ...profileData,
                    remote: e.target.checked,
                  })
                }
              />
            </div>
          </div>
          <button className="btn btn-dark" type="submit">
            Zapisz zmiany
          </button>
        </form>
      )}
    </>
  );
};

export default UserForm;
